(function () {
    'use strict';

    angular.module('appliances')
        .controller('AppliancesUpdateController', AppliancesUpdateController);

    AppliancesUpdateController.$inject = ['$state', 'appliancesDataSrvc', 'notificationSrvc', 'appliancesMessagesConst', 'errorNotificationSrvc'];

    function AppliancesUpdateController($state, appliancesDataSrvc, notificationSrvc, appliancesMessagesConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name_pl: [],
            description_pl: [],
            name_en: [],
            description_en: [],
            name_de: [],
            description_de: [],
            title_cpde: [],
            description_cpde: [],
            title_cpen: [],
            description_cpen: [],
            icon: [],
            nonFieldErrors: []
        };
        self.appliancesData = {};
        self.categoriesList = [];

        self.updateAppliance = updateAppliance;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getAppliance();
        }

        function getAppliance() {
            return appliancesDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(function (response) {
                self.appliancesData = response;

                delete self.appliancesData.date_modified;
                delete self.appliancesData.date_added;
                return response;
            });
        }

        function updateAppliance() {
            appliancesDataSrvc.update({
                pk: self.appliancesData.pk
            }, self.appliancesData).$promise.then(
                function (response) {
                    notificationSrvc.notification("success", appliancesMessagesConst.update);
                    $state.go('layout.appliances.list');
                },
                function (response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
